<template>
  <div class="container-modal">
    <div
      class="modal fade"
      :id="`${type}-modal`"
      tabindex="-1"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header u-marg-b-xxs">
            <span class="modal-title h5 u-bold" id="plan-modal-title">{{ modal.title }}</span>
            <button type="button" class="close" data-dismiss="modal">
              <span class="sr-only">{{ $t("Close")}}</span>
            </button>
          </div>
          <div class="modal-body u-marg-t-xxs">
            <div class="modal-body-container__text" v-html="modal.content">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: () => ''
      },
      traduction: {
        type: Function
      },
      modal: {
        type: Object,
        default: {}
      }
    },
    computed: {
      $t () {
        return this.traduction
      }
    },
  }
</script>
